import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/digital-whisper.vue
var o = {
	name: "DtIconDigitalWhisper",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--digital-whisper"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Digital Whisper",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M2.146 10.146a.5.5 0 1 1 .708.707l-1 1A.5.5 0 0 1 1 11.5v-1a.5.5 0 0 1 .967-.175l.18-.178ZM5.25 9a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm2.5 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1ZM10 8.5a.5.5 0 0 1 1 0A1.5 1.5 0 0 1 9.5 10a.5.5 0 0 1 0-1 .5.5 0 0 0 .5-.5ZM1 9V8a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0Zm0-2.75v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0Zm9 0v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0ZM1 3.5A1.5 1.5 0 0 1 2.5 2a.5.5 0 0 1 0 1 .5.5 0 0 0-.5.5.5.5 0 0 1-1 0Zm9 0a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1A1.5 1.5 0 0 1 11 3.5a.5.5 0 0 1-1 0ZM5.25 2a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm2.5 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=digital-whisper.js.map